//? Commented code is to show city score per variable and total per category or to blur all the score

import { OverlayTrigger } from "react-bootstrap"

import { useGeneralStates } from "../../context/general-context"
import { VAR_BLOCKED } from "./utils"
import infoIcon from "../../assets/images/infoBlue.svg"
import { useAuth } from "../../context/auth-context"

export default function MobileVariablesTable(props) {
    const { 
        category,
        handleShowModal,
        descriptionTooltip,
        isTextBlur
    } = props

    const { user } = useAuth()
    const { showSubscribeModal, triggerDetailsSection } = useGeneralStates()
    
    function handleDetailsButton(varId) {
        if (VAR_BLOCKED.includes(varId.toString())) {
            showSubscribeModal()

            return
        }

        triggerDetailsSection(varId)
    }
    
    return (
        <table className="mobile-results-table">
            <thead>
                <tr>
                    <th>
                        <div className="headerWithIcon">
                            <span>Cities</span>

                            <OverlayTrigger placement="top" overlay={descriptionTooltip("weight")}>
                                <img src={infoIcon} alt="Prodensa Teaser" />
                            </OverlayTrigger>
                        </div>
                    </th>

                    {category.variables.sort((a, b) => a.position - b.position).filter(varRefFilter => varRefFilter.weight !== 0).map(varRef => {
                            return (
                                <th key={varRef._id}>
                                    <div>
                                        <img 
                                            src={infoIcon} 
                                            className="info-icon" 
                                            alt="Prodensa Automation"
                                            onClick={() => handleShowModal(category._id, varRef._id)}
                                        />
                                        <h5 className="var-title">{varRef.title}</h5>
                                        <div className="title-criteria-container">
                                            <button className="criteria-button" 
                                                onClick={showSubscribeModal}>
                                                Criteria
                                            </button>
                                            <button className="btnBgBlueTextGradient mobile-details-button" onClick={() => handleDetailsButton(varRef._id)} />
                                        </div>
                                    </div>
                                </th>
                            )
                        })
                    }

                    <th>Total</th>
                </tr>
            </thead>

            <tbody>
                {user?.selectedCities?.map(city => {
                    const cityTotal = user?.result?.filter(varResult => varResult.catRefId === category._id)
                    ?.reduce((acc, curr) => {
                        const cityPoints = curr.citiesResults.find(cityResult => cityResult.datamexico_municipality_id === city.datamexico_municipality_id)?.points

                        return acc + cityPoints
                    }, 0).toFixed(1)
                    
                    return (
                        <tr key={`variable-row-mobile-${city.datamexico_municipality_id}`}>
                            <td>{city.municipality_name}</td>

                            {category.variables.sort((a, b) => a.position - b.position).filter(varRefFilter => varRefFilter.weight !== 0).map(variable => {
                                const cityResult = user?.result?.find(varResult => varResult.varRefId === variable._id)
                                ?.citiesResults.find(cityResult => cityResult.datamexico_municipality_id === city.datamexico_municipality_id)

                                const cityCost = cityResult?.cost

                                const cityScore = cityResult?.score

                                const dataToShow = VAR_BLOCKED.includes(variable._id.toString()) ? "N/A" : cityCost ? cityScore : "N/A"
                                const dataClass = VAR_BLOCKED.includes(variable._id.toString()) ? "teaserDataHide" : ""

                                return (
                                    <td 
                                        key={`variable-mobile-city-score-${city.datamexico_municipality_id}-${variable._id}`}
                                        className={dataClass} 
                                        // className="teaserDataHide" 
                                    >
                                        {/* N/A */}
                                        {dataToShow}
                                    </td>
                                )
                            })}

                            <td className={isTextBlur}>{cityTotal}</td>
                            {/* <td className="teaserDataHide">N/A</td> */}
                        </tr>
                    )
                }
                )}
            </tbody>
        </table>
    )
}
